module.exports = __webpack_public_path__ + "img/img14.0873f97f.svg";